import {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATHS} from 'routes/constants';
import {usePath, useReservationSettings} from 'hooks';
import {useComputedOnboardingDetails} from 'hooks/useComputedOnboardingDetails';
import {CustomIcon} from '@guestapp/old-ui-kit';
import welcomeHand from 'assets/img/welcome-hand.svg';
import {AuthPageHeader} from '../components/AuthPage';
import {
  WelcomeWrapper,
  StyledImg,
  WelcomeTitle,
  WelcomeSubtitle,
  ContinueToReservationButton,
  WelcomeContainer,
} from '../styled';

export const WelcomeView = () => {
  const {t} = useTranslation();

  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {areGuestCreated} = useComputedOnboardingDetails();
  const {checkCanEditReservationDetails} = useReservationSettings();

  const handleContinue = useCallback(() => {
    const shouldGoToHome = areGuestCreated || !checkCanEditReservationDetails();
    const nextPath = shouldGoToHome ? PATHS.home : PATHS.onboarding.numberOfGuests;

    navigate(getFullPath(nextPath), {
      replace: true,
    });
  }, [getFullPath, navigate, areGuestCreated, checkCanEditReservationDetails]);

  return (
    <WelcomeContainer className="auth__welcome-view">
      <AuthPageHeader onClickLogo={() => {}} />
      <WelcomeWrapper>
        <StyledImg src={welcomeHand} alt="welcome hand" width={104} height={104} />
        <WelcomeTitle>{t('welcome')}</WelcomeTitle>
        <WelcomeSubtitle>{t('auth.welcome_view_description')}</WelcomeSubtitle>
        <ContinueToReservationButton
          position="right"
          label={t('auth.continue_to_reservation')}
          customIcon={<CustomIcon name="whiteArrowRight" size={16} />}
          onClick={handleContinue}
        />
      </WelcomeWrapper>
    </WelcomeContainer>
  );
};
